// material-ui
import React, { useEffect, useState } from 'react';

// project imports
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';
import getValues, { getValuesAsync } from 'service/chart-service';
import { getDevicesAsyncDTC, getDeviceByIDAsync, getDeviceByIDAsyncDTC } from 'service/device-service';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@mui/material';
import getDTCsAll, { DtcRequestBody } from 'service/dtc-service';
import { gridSpacing } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import StartTime from 'views/variables/starttime';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import getVariablesAsync from 'service/variable-service';

// ==============================|| SAMPLE PAGE ||============================== //

const DTC = () => {
    localStorage.setItem('currentPage', '/dtc');

    const [content, setContent] = React.useState<ListProps>({
        title: 'DTC',
        content: { data: [], headers: [] },
        allowCSVExport: true
    });
    const [resultsFound, setResultsFound] = useState<boolean>(false);
    const [expanded, setExpanded] = React.useState<boolean>(false);
    const [waitingForResponse, setWaitingForResponse] = React.useState<boolean>(false);

    const [devices, setDevices] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [projects, setProjects] = useState<any[]>([]);
    const [vehicles, setVehicles] = useState<any[]>([]);

    const [selectedSN, setSelectedSN] = useState<string[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
    const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
    const [selectedStartTime, setSelectedStartTime] = useState<Date>(new Date(new Date().setHours(new Date().getHours() - 2)));
    const [selectedEndTime, setSelectedEndTime] = useState<Date>(new Date());
    useEffect(() => {
        const fetchValues = async () => {
            console.log('fetching values');

            try {
                const requestBody: DtcRequestBody = {
                    page: 1,
                    pageSize: 100
                };

                // console.log('request body: ', JSON.stringify(requestBody));

                const response = await getDTCsAll(requestBody);
                if (response.data.length > 0) {
                    setResultsFound(true);
                    let headers: any[] = [];
                    Object.keys(response.data[0]).forEach((keys: any) => {
                        // const keys = Object.keys(data);
                        // keys.forEach((key) => {
                        //     if (key !== 'key') headers.push(key);
                        // });
                        headers.push(keys);
                        console.log(keys);
                    });
                    const contentResponse: Content = {
                        data: response.data,
                        headers: headers.map((header) => {
                            return {
                                title: header,
                                value: header
                            };
                        })
                    };
                    setContent({
                        title: 'Last 100 DTCs',
                        content: contentResponse,
                        allowCSVExport: true
                    });
                    console.log(contentResponse);
                } else {
                    setResultsFound(false);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            }
        };
        fetchValues();
    }, []);

    useEffect(() => {
        const fetchDropDowns = async () => {
            try {
                console.log('HERE');
                const devicesResponse = await getDevicesAsyncDTC();
                setDevices(devicesResponse);
                console.log(devicesResponse);

                const customersResponse: Set<string> = new Set();
                devicesResponse.forEach((device: any) => {
                    if (device.Customer !== null) {
                        customersResponse.add(device.Customer);
                    }
                });
                setCustomers(Array.from(customersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    const handleCustomerChange = (_event: any, value: string[]) => {
        setSelectedCustomers(value);
        const projectsResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (value.includes(device.Customer) && device['Project Number'] !== null) {
                projectsResponse.add(device['Project Number']);
            }
        });
        setProjects(Array.from(projectsResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };
    const handleProjectChange = (_event: any, value: string[]) => {
        setSelectedProjects(value);
        const vehiclesResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (selectedCustomers.includes(device.Customer) && value.includes(device['Project Number']) && device['Vehicle ID'] !== null) {
                vehiclesResponse.add(device['Vehicle ID']);
            }
        });
        setVehicles(Array.from(vehiclesResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };
    const handleVehicleChange = (_event: any, value: string[]) => {
        setSelectedVehicles(value);
        let serialNumbersResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (
                selectedCustomers.includes(device.Customer) &&
                selectedProjects.includes(device['Project Number']) &&
                value.includes(device['Vehicle ID'])
            ) {
                serialNumbersResponse.add(device['Device ID']);
            }
        });
        setSelectedSN(Array.from(serialNumbersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };

    const handleStartTimeChange = (value: any) => {
        setSelectedStartTime(value);
    };

    const handleEndTimeChange = (value: Date) => {
        setSelectedEndTime(value);
    };

    const handleAccordianChange = (event: any) => {
        setExpanded(!expanded);
    };

    const handleSubmit = async (e: any) => {
        setWaitingForResponse(true);
        setExpanded(false);
        e.preventDefault();

        const startTime: string = selectedStartTime !== undefined ? selectedStartTime?.toISOString().replace('T', ' ').slice(0, 23) : '';
        const endTime: string = selectedEndTime !== undefined ? selectedEndTime?.toISOString().replace('T', ' ').slice(0, 23) : '';

        // const allVariables = [
        //     ...selectedLeftVariables.map((leftVariable) => ({ value: leftVariable, axis: 'left' })),
        //     ...selectedRightVariables.map((rightVariable) => ({ value: rightVariable, axis: 'right' }))
        // ];

        const requestBody: DtcRequestBody = {
            sns: selectedSN,
            startTimeStamp: startTime,
            endTimeStamp: endTime,
            page: 1,
            pageSize: 100000
        };

        try {
            let foundDevices = new Map();
            const response = await getDTCsAll(requestBody);
            if (response.data.length > 0) {
                setResultsFound(true);
                let headers: any[] = []; // ['Customer', 'Project Number', 'Vehicle ID'];
                Object.keys(response.data[0]).forEach((key: any) => {
                    headers.push(key);
                });
                for (let row of response.data) {
                    if (!foundDevices.has(row.DeviceSN)) {
                        const deviceBySN = await getDeviceByIDAsyncDTC({ SN: row.DeviceSN });
                        foundDevices.set(row.DeviceSN, deviceBySN);
                    }
                    const foundDevice = foundDevices.get(row.DeviceSN);
                    // row.Customer = foundDevice.Customer;
                    // row['Project Number'] = foundDevice['Project Number'];
                    // row['Vehicle ID'] = foundDevice['Vehicle ID'];
                    row.Customer = foundDevice.Customer;
                    row.Project = foundDevice['Project Number'];
                    row.Vehicle = foundDevice['Vehicle ID'];
                }

                const contentResponse: Content = {
                    data: response.data,
                    headers: headers.map((header) => {
                        return {
                            title: header,
                            value: header
                        };
                    })
                };
                setContent({
                    title: `Results for ${selectedVehicles.length} Vehicle(s)`,
                    content: contentResponse,
                    allowCSVExport: true
                });
            } else {
                setResultsFound(false);
            }

            setWaitingForResponse(false);
        } catch (error) {
            console.error('Error submitting data:', error);
            setWaitingForResponse(false);
        }
    };

    return (
        <div>
            <Accordion key={'accordion'} expanded={expanded} onChange={handleAccordianChange}>
                <AccordionSummary
                    key={'accordionSummary'}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {!expanded ? (
                        selectedCustomers.length > 0 ? (
                            selectedCustomers.map((customer, index) => {
                                return (
                                    <Typography key={'accordionSummaryClosed'}>
                                        Customer: {customer}&emsp;&emsp;|&emsp;&emsp;Project Number: {selectedProjects[index]}
                                        &emsp;&emsp;|&emsp;&emsp;Vehicle ID: {selectedVehicles[index]}&emsp;&emsp;|&emsp;&emsp;Start Time:{' '}
                                        {selectedStartTime.getMonth() + 1}/{selectedStartTime.getDate()}/{selectedStartTime.getFullYear()}{' '}
                                        {selectedStartTime.getHours()}:
                                        {selectedStartTime.getMinutes() === 0 ? '00' : selectedStartTime.getMinutes()}
                                        &emsp;&emsp;|&emsp;&emsp;End Time: {selectedEndTime.getMonth() + 1}/{selectedEndTime.getDate()}/
                                        {selectedEndTime.getFullYear()} {selectedEndTime.getHours()}:
                                        {selectedEndTime.getMinutes() === 0 ? '00' : selectedEndTime.getMinutes()}
                                    </Typography>
                                );
                            })
                        ) : (
                            <Typography key={'accordionSummaryOpen'}>Filters</Typography>
                        )
                    ) : (
                        <Typography key={'accordionInstructions'}>Filters</Typography>
                    )}
                </AccordionSummary>
                <AccordionDetails key={'accordionDetails'}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12} md={6} lg={3}>
                                <SubCard
                                    title={
                                        <span>
                                            Customer <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                >
                                    <Grid container direction="column" spacing={3}>
                                        <Grid item>
                                            <Autocomplete
                                                key={'selectedCustomers'}
                                                multiple
                                                limitTags={2}
                                                options={customers}
                                                getOptionLabel={(option: any) => option}
                                                value={selectedCustomers}
                                                onChange={handleCustomerChange}
                                                // defaultValue={}
                                                style={{ width: '15rem' }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <SubCard
                                    title={
                                        <span>
                                            Project Number <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                >
                                    <Grid container direction="column" spacing={3}>
                                        <Grid item>
                                            <Autocomplete
                                                key={'selectedProjects'}
                                                multiple
                                                limitTags={2}
                                                options={projects}
                                                getOptionLabel={(option) => option}
                                                value={selectedProjects}
                                                onChange={handleProjectChange}
                                                // defaultValue={}
                                                style={{ width: '15rem' }}
                                                //disabled={selectedCustomers.length === 0}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <SubCard
                                    title={
                                        <span>
                                            Vehicle ID <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                >
                                    <Grid container direction="column" spacing={3}>
                                        <Grid item>
                                            <Autocomplete
                                                key={'selectedVehicles'}
                                                multiple
                                                limitTags={2}
                                                options={vehicles}
                                                getOptionLabel={(option) => option}
                                                value={selectedVehicles}
                                                onChange={handleVehicleChange}
                                                // defaultValue={}
                                                style={{ width: '15rem' }}
                                                //disabled={selectedCustomers.length === 0 || selectedProjects.length === 0}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3} display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
                                <StartTime
                                    key={'startTime'}
                                    timeLabel={
                                        <span>
                                            Start Time <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    value={selectedStartTime}
                                    onChange={handleStartTimeChange}
                                    time={selectedStartTime}
                                    myMargin={'normal'}
                                ></StartTime>
                                <StartTime
                                    key={'endTime'}
                                    timeLabel={
                                        <span>
                                            End Time <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    value={selectedEndTime}
                                    onChange={handleEndTimeChange}
                                    time={selectedEndTime}
                                    myMargin={'normal'}
                                ></StartTime>
                            </Grid>
                            <Grid item lg={5}></Grid>
                            <Grid item lg={2} display={'flex'} alignItems={'center'} paddingTop={'24px'}>
                                <Button
                                    key={'submitButton'}
                                    variant="contained"
                                    type="submit"
                                    style={{ marginTop: '16px', marginBottom: '8px', height: '51.25px' }}
                                    disabled={
                                        selectedCustomers.length === 0 || selectedProjects.length === 0 || selectedVehicles.length === 0
                                    }
                                >
                                    Create
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>
            {waitingForResponse ? (
                <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                    <Box key={'loadingList'} sx={{ display: 'flex' }}>
                        <CircularProgress />
                    </Box>
                </Grid>
            ) : resultsFound ? (
                <Grid item lg={12} paddingTop={'1rem'}>
                    <ReusableList
                        key={content?.content?.data.length}
                        title={content.title}
                        content={content.content}
                        allowCSVExport={content.allowCSVExport}
                    ></ReusableList>
                </Grid>
            ) : (
                <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                    <Typography key={'noResults'} fontWeight={'bold'} fontSize={'2rem'}>
                        No Results for selected criteria
                    </Typography>
                </Grid>
            )}
        </div>
    );
};

export default DTC;
